import { createContext, useContext, useState, ReactNode } from 'react';

interface SearchResult {
  userId: string;
  fullCV: string;
  explanation: string;
}

interface SearchContextType {
  searchResults: SearchResult[];
  setSearchResults: (results: SearchResult[]) => void;
}

const SearchContext = createContext<SearchContextType | null>(null);

export function SearchProvider({ children }: { children: ReactNode }) {
  const [searchResults, setSearchResults] = useState<SearchResult[]>([]);

  const updateSearchResults = (results: SearchResult[]) => {
    setSearchResults(results);
  };

  return (
    <SearchContext.Provider value={{ searchResults, setSearchResults: updateSearchResults }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearchResults() {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchResults must be used within a SearchProvider');
  }
  return context;
}